<div class="card overflow-hidden">
  <div class="card-body" [class.pb-0]="!graphPadding">
    <div class="d-flex align-items-center">
      <div class="subheader">@if (iconSvg) { <app-dashboard-icon [svg]="iconSvg" class="me-2"></app-dashboard-icon> } {{ title }}</div>
      <div class="ms-auto lh-1 range-control">
        @if (showTimeWindowPicker) {
          <button type="button" class="btn btn-link btn-sm dropdown-toggle text-secondary p-0" [attr.aria-expanded]="rangeOpen" [attr.aria-label]="'Select time range for ' + title" (click)="rangeOpen = !rangeOpen">{{ displayedWindowLabel }}</button>
          @if (rangeOpen) {
            <div class="dropdown-menu dropdown-menu-end show">
              @for (option of timeWindowOptions; track option.label; let index = $index) {
                <button type="button" class="dropdown-item" [class.active]="index === selectedWindowIndex" (click)="selectWindow(index)">{{ option.label }}</button>
              }
            </div>
          }
        } @else if (displayedWindowLabel) {
          <span class="text-secondary small">{{ displayedWindowLabel }}</span>
        }
      </div>
    </div>

    @if (loading) {
      <div class="widget-loading"><span class="spinner-border spinner-border-sm" aria-hidden="true"></span>Loading report…</div>
    } @else if (error) {
      <div class="widget-error mt-2" role="alert">{{ error }}</div>
    } @else {
      <div class="d-flex align-items-baseline">
        <div class="h1 mb-0 me-2">{{ formattedValue }}</div>
        <div class="me-auto">
          <span class="d-inline-flex align-items-center lh-1" [class.text-green]="change > 0" [class.text-red]="change < 0" [class.text-yellow]="change === 0">
            {{ change | number:'1.0-1' }}%
            @if (change !== 0) {
              <svg class="icon ms-1 icon-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                @if (change > 0) { <path d="M3 17l6-6 4 4 8-8"></path><path d="M14 7h7v7"></path> }
                @else { <path d="M3 7l6 6 4-4 8 8"></path><path d="M21 10v7h-7"></path> }
              </svg>
            } @else {
              <svg class="icon ms-1 icon-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14"></path></svg>
            }
          </span>
        </div>
      </div>
    }
  </div>

  @if (!loading && !error && series.length) {
    <div class="chart-container" [class.chart-container--padded]="graphPadding" [style.min-height.px]="chartHeight"><div #chartHost [style.min-height.px]="chartHeight"></div></div>
  }
</div>
